import { setVuetifyTheme } from './vuetify-theme'
import { getOrCreateStyleBlock, createVuetifyTextColorCSS, createCssVariablesCode, updateBodyThemeClass } from './css-generator'
import { createColorPallet, getTextColor, tintColor } from './color-utils'

export const initThemeFromColor = (primary, onColors = true) => {
    if (!primary) { return }

    const secondary = tintColor(primary, 0.2)

    const theme = {
        colors: {
            primary: primary,
            ...createColorPallet('primary', primary),
            secondary: secondary,
            ...createColorPallet('secondary', secondary),
            // 'text-headline': '#000000',
            'text-link': '#1687e4',
        },
        dark: false
    }

    if (onColors) {
        theme.colors['on-primary'] = getTextColor(primary)
        theme.colors['on-secondary'] = getTextColor(secondary)
    }

    return theme
}

export const TenantThemePlugin = {
    install(Vue) {
        let theme = { colors: {}, dark: false }

        const setTheme = (newTheme) => {
            theme = newTheme
            setVuetifyTheme(theme.colors, theme.dark)
            updateBodyThemeClass(theme.dark ? 'dark' : 'light')

            const variablesCSS = createCssVariablesCode(theme.colors)
            const textColorCSS = createVuetifyTextColorCSS(theme.colors)

            getOrCreateStyleBlock('q-tenant-theme-css-patch').innerHTML = variablesCSS + textColorCSS
        }

        Vue.mixin({
            methods: {
                $setTenantTheme: setTheme,
                $getTenantTheme: () => theme
            },

            computed: {
                $tenantTheme() {
                    return this.current_tenant?.TenantConfig.features.Theme || initThemeFromColor(this.current_tenant?.TenantConfig.features.UIColor.hex)
                }
            }
        })

        new Vue({
            watch: {
                '$tenantTheme'(newValue) {
                    if (!newValue || newValue === theme) { return }
                    setTheme(newValue)
                }
            }
        })
    }
}